import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { Message } from 'jl-design-system/components/message/Message';
import styles from './SingleErrorMessage.scss';

const findMessage = (messages, forType) => messages.find((message) => message.type === forType);

export const SingleErrorMessage = ({ forType, errorMessages = [] }) => {
  const message = findMessage(errorMessages, forType);
  return message ? (
    <div className={styles.SingleErrorMessage}>
      <Message title={message.title || message.description} type="error" whiteBackground="false" />
    </div>
  ) : null;
};

export const mapStateToProps = ({
  messages: {
    app: { errorMessages },
  },
}) => ({ errorMessages });

export const mapStateToModalProps = ({
  messages: {
    modal: { errorMessages },
  },
}) => ({ errorMessages });

export const ConnectedSingleErrorMessage = connect(mapStateToProps)(SingleErrorMessage);
export const ConnectedSingleModalErrorMessage = connect(mapStateToModalProps)(SingleErrorMessage);

SingleErrorMessage.propTypes = {
  forType: PropTypes.string.isRequired,
  errorMessages: PropTypes.arrayOf(PropTypes.shape({})),
  children: PropTypes.node,
};
